import React, { Component } from "react";
import {
  getCouponsList,
  removeCouponItem,
  getAllBrands,
  gregorian_to_jalali,
} from "../../modules/Api";
import ReactTable from "react-table";
import history from "../../modules/History";
import { Button, notification } from "antd";
import { END_POINT } from "../../constants/config";
import ACL from "../../components/ACL";
import { Form, Select } from "antd";
const FormItem = Form.Item;

class Coupons extends Component {
  constructor() {
    super();
    this.state = {
      items: [],
      pageSize: 15,
      count: 0,
      last_page: 1,
    };
    this.brands = [];
  }
  componentDidMount() {
    this.fetchData();
    getAllBrands("", (res) => {
      this.setBrands(res);
    });
  }
  setBrands(brands) {
    this.brands = brands;
  }

  fetchData = (query = "") => {
    getCouponsList(query, (res) => {
      this.setState({
        items: res.data.data,
        last_page: res.data.last_page,
        count: res.data.total,
        pageSize: res.data.per_page,
      });
    });
  };

  onChange(state) {
    this.setState({ pageSize: state.pageSize });
    let sort = {
      order: "desc",
      field: "created_at",
    };
    if (state.sorted.length > 0) {
      sort = {
        order: state.sorted[0].desc ? "desc" : "asc",
        field: state.sorted[0].id,
      };
    }

    let filterQuery = state.filtered.reduce((q, item) => {
      return item.value ? `${q}&${item.id}=${item.value}` : q;
    }, "");

    const query = `page=${state.page + 1}&per_page=${
      state.pageSize
    }&${filterQuery}&sort=${JSON.stringify(sort)}`;
    this.fetchData(query);
  }

  removeCoupon(id) {
    const warningMessage = `آیا از حذف کوپن اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
    if (window.confirm(warningMessage)) {
      removeCouponItem(id, () => {
        notification.open({
          message: `کوپن با موفقیت حذف شد!`,
          description: `تمامی اطلاعات کوپن با موفقیت حذف شدند.`,
        });
      });
      this.fetchData();
    }
  }
  brandOptions() {
    let opt = [];
    for (let i = 0; i < this.brands.length; i++) {
      opt.push(
        <option value={this.brands[i].id}>{this.brands[i].name}</option>
      );
    }
    return opt;
  }
  brandFilterOption = (input, option) => option.key.includes(input);

  render() {
    const brands = this.brands;
    const columns = [
      {
        Header: "آیدی",
        accessor: "mpn_id",
        filterable: true,
      },
      {
        Header: "عنوان",
        accessor: "title",
        filterable: true,
        Cell: (row) => (
          <ACL
            component="div"
            has_permission="coupons_management|coupons_edit"
            denied={() => {
              return row.original.title;
            }}
          >
            <span
              style={{ color: "rgb(39, 105, 125)", cursor: "pointer" }}
              title={row.original.title}
              onClick={() => {
                window.open(`/coupons/edit/${row.original.mpn_id}`, "_blank");
              }}
            >
              {" "}
              {row.original.title}{" "}
            </span>
          </ACL>
        ),
      },
      {
        Header: "کد تخفیف",
        accessor: "code",
        filterable: true,
        Cell: (row) => (
          <span title={row.original.code}> {row.original.code} </span>
        ),
      },
      {
        Header: "طرح",
        accessor: "plan",
        filterable: true,
        Cell: (row) => (
          <span title={row.original.plan_enum_title}>
            {" "}
            {row.original.plan_enum_title}{" "}
          </span>
        ),
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : null}
          >
            <option></option>
            <option value="0">رایگان</option>
            <option value="1">همکاری</option>
          </select>
        ),
      },
      {
        Header: "کانال",
        accessor: "channel",
        filterable: true,
        Cell: (row) => (
          <span
            title={
              row.original.is_signup == 1
                ? "ثبت نامی"
                : row.original.channel_enum_title
            }
          >
            {" "}
            {row.original.is_signup == 1
              ? "ثبت نامی"
              : row.original.channel_enum_title}{" "}
          </span>
        ),
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : null}
          >
            <option></option>
            <option value="0">همه</option>
            <option value="1">وبسایت</option>
            <option value="2">اپلیکیشن</option>
            <option value="4">ثبت نامی</option>
          </select>
        ),
      },
      {
        Header: "فروشگاه",
        accessor: "brand_id",
        sortable: false,
        filterable: true,

        Cell: (row) => (
          <span title={row.original.brand.name}>
            {" "}
            {row.original.brand.name}{" "}
          </span>
        ),
        Filter: ({ filter, onChange }) => (
          <Select
            onChange={(value) => onChange(value)}
            style={{ width: "100%" }}
            placeholder="انتخاب فروشگاه"
            filterOption={this.brandFilterOption}
            showSearch={true}
          >
            {brands.map((s) => (
              <Select.Option value={s.id} key={`ss__${s.name}`}>
                {s.name}{" "}
              </Select.Option>
            ))}
          </Select>
        ),
      },
      {
        Header: "تاریخ انقضا",
        accessor: "coupon.expire_date",
        filterable: true,
        sortable: false,
        Cell: (row) =>
          row.original.expiration_date == null ? (
            <span>بدون انقضا</span>
          ) : (
            <span
              title={gregorian_to_jalali(
                row.original.expiration_date.split(" ")[0].split("-")[0],
                row.original.expiration_date.split(" ")[0].split("-")[1],
                row.original.expiration_date.split(" ")[0].split("-")[2]
              )}
            >
              {gregorian_to_jalali(
                row.original.expiration_date.split(" ")[0].split("-")[0],
                row.original.expiration_date.split(" ")[0].split("-")[1],
                row.original.expiration_date.split(" ")[0].split("-")[2]
              )}
            </span>
          ),
        Filter: ({ filter, onChange }) => (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : null}
          >
            <option></option>
            <option value="0">همه</option>
            <option value="1">منقضی شده</option>
            <option value="2">فعال</option>
          </select>
        ),
      },
      {
        Header: "بازخورد",
        accessor: "feedback_ratio",
        Cell: (row) => {
          // const colorStyle = row.original.feedback_ratio_diffrence > 0 ? {color :'green'} : {color :'red'};

          return (
            <span title={row.original.feedback_ratio}>
              {row.original.feedback_ratio}
              {/* <span style={{...feedbackStyle, ...colorStyle}}>{round(row.original.feedback_ratio_diffrence, 2)}</span>  */}
            </span>
          );
        },
      },
      {
        Header: "تعدادکوپنها",
        accessor: "unique_codes_count",
        Cell: (row) => {
          return (
            <span title={row.original.unique_codes_count}>
              {row.original.unique_codes_used_count} از{" "}
              {row.original.unique_codes_count}
            </span>
          );
        },
      },
      {
        Header: "عملیات",
        accessor: "delete",
        sortable: false,
        Cell: (row) => (
          <React.Fragment>
            <ACL
              component="span"
              has_permission="coupons_management|coupons_delete"
            >
              <span
                onClick={() => {
                  this.removeCoupon(row.original.id);
                }}
                style={{ color: "tomato", cursor: "pointer", marginTop: "20%" }}
              >
                X{" "}
              </span>
            </ACL>
            <ACL
              component="span"
              has_permission="coupons_management|coupons_history"
            >
              <span
                onClick={() =>
                  history.item.push(`/history/coupon/${row.original.id}`)
                }
                className="link"
              >
                H
              </span>
            </ACL>
          </React.Fragment>
        ),
      },
    ];
    return (
      <div style={{ textAlign: "center" }}>
        <div className="btn-container">
          <ACL component="div" has_permission="coupons_management|coupons_add">
            <Button
              type="primary"
              onClick={() => {
                window.open(`/coupons/add`, "_blank");
              }}
            >
              افزودن کوپن جدید
            </Button>
          </ACL>
          <ACL
            component="div"
            has_permission="coupons_management|coupons_history"
          >
            <Button
              type="secondary"
              onClick={() => history.item.push(`/history/coupon`)}
            >
              تاریخچه تغییرات
            </Button>
          </ACL>
        </div>

        <ReactTable
          data={this.state.items}
          columns={columns}
          manual
          onFetchData={(state) => {
            this.onChange(state);
          }}
          defaultPageSize={parseInt(this.state.pageSize, 10)}
          pages={this.state.last_page}
        />
      </div>
    );
  }
}

export default Coupons;



// WEBPACK FOOTER //
// ./src/containers/Coupons/index.js